import { render, staticRenderFns } from "./DemographicsSection.vue?vue&type=template&id=8426f3ac&"
import script from "./DemographicsSection.vue?vue&type=script&lang=js&"
export * from "./DemographicsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports